export class InvCyclicLayoutModel{
    pallets:number;
    serials:number;
    accesories:number;
    sapCodes:number;
    locations:number;

    constructor(){}
}